import { render, staticRenderFns } from "./DetailSettingsCols.vue?vue&type=template&id=942adaa8"
import script from "./DetailSettingsCols.vue?vue&type=script&lang=ts"
export * from "./DetailSettingsCols.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942adaa8')) {
      api.createRecord('942adaa8', component.options)
    } else {
      api.reload('942adaa8', component.options)
    }
    module.hot.accept("./DetailSettingsCols.vue?vue&type=template&id=942adaa8", function () {
      api.rerender('942adaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/DetailSettingsCols.vue"
export default component.exports